module.exports = __webpack_public_path__ + "img/aed6f57ffe1dd8195118c5483a886a25.894da738.jpg";